import endpoints, { formatEndpoint } from '../endpoints';
import { RestManagerWithoutBaseUrl } from '../RestManager';
import { mapEnvironmentPropertiesResponse } from './interceptors';
class Api {

    getEnvironmentProperties() {
        const endpoint = formatEndpoint(endpoints.environmentProperties);

        return RestManagerWithoutBaseUrl.get(endpoint).then(mapEnvironmentPropertiesResponse);
    }
}

export default new Api();
